export * from './written-besichtigungs-status.event.interface';
